<template>
  <div class>
    <!--     back to store button start  -->
    <div
      v-if="fullScreen && multiStepIndex === 1 && !isMobile()"
      class="container-fluid banner-alt"
      :class="isMobile() && 'mt-3'"
    >
      <div class="row">
        <div class="col-12 banner-title">
          <span class="material-icons md-36 font-31" @click="goBack"
            >keyboard_arrow_left</span
          >
        </div>
      </div>
    </div>
    <!--     back to store button end  -->

    <div class="d-flex justify-content-center">
      <div class="col-12 pl-0 pr-0">
        <!--     multi step register full screen form begins -->

        <!--     go back step icon   -->
        <div
          v-if="multiStepIndex > 1"
          class="d-flex px-3 align-items-center cursor-pointer"
          @click="goBackMultiStepForm"
        >
          <span class="material-icons md-36 font-31">keyboard_arrow_left</span>
          <span class="cursor-pointer">
            {{ $t("message.back") }}
          </span>
        </div>
        <!--     go back step end   -->

        <b-progress
          v-if="isBranded() && fullScreen"
          :max="4"
          :value="multiStepIndex"
          class="mt-3 w-100"
          height="0.5rem"
        ></b-progress>
        <form
          v-if="isBranded() && fullScreen"
          autocomplete="off"
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center container-fluid pl-4 pr-4"
          @submit.prevent="register"
        >
          <h3
            v-if="multiStepIndex === 1"
            class="w-100 mt-3 d-flex pt-2 justify-content-start"
          >
            {{ $t("message.createYourAccount") }}
          </h3>

          <h3
            v-if="multiStepIndex === 2"
            class="w-100 mt-3 d-flex pt-2 justify-content-start"
          >
            {{ $t("message.secureAccount") }}
          </h3>

          <div
            v-if="multiStepIndex === 3"
            class="justify-content-start d-flex pt-2 w-100"
          >
            <p class="pr-2 font-weight-light">
              {{ $t("message.enterCodeSentTo") }}
            </p>
            <p class="pr-2 font-weight-light">
              {{ formatMobile(mobile, countryCode) }}
            </p>
          </div>
          <div v-else class="justify-content-start d-flex pt-2 w-100">
            <h5 class="pr-2 font-weight-light">
              {{ $t("message.alreadyMember") }}
            </h5>
            <h5 class="text-primary cursor-pointer" @click="goToSignIn(0)">
              {{ $t("message.signInHere") }}
            </h5>
          </div>

          <!--          multi form step 1 -->
          <form
            v-if="multiStepIndex === 1"
            class="w-100 mt-4 d-flex flex-column"
            @submit.prevent="goToStepTwo"
          >
            <div>
              <div class="form-group w-100">
                <label for="First Name"
                  >{{ $t("message.firstName") }}
                  <span class="required-logo">*</span></label
                >
                <input
                  id="FirstName"
                  v-model="firstName"
                  v-validate="'required|min:2|alpha'"
                  class="form-control"
                  name="firstName"
                  type="text"
                />
                <div class="invalid-feedback">
                  {{
                    OOErrors.first("firstName") | inputNameLocale("firstName")
                  }}
                </div>
              </div>

              <div class="form-group w-100">
                <label for="Last Name"
                  >{{ $t("message.lastName") }}
                  <span class="required-logo">*</span></label
                >
                <input
                  id="LastName"
                  v-model="lastName"
                  v-validate="'required|min:2|alpha'"
                  class="form-control"
                  name="lastName"
                  type="text"
                />
                <div class="invalid-feedback">
                  {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}
                </div>
              </div>

              <div v-if="!isRolldStore()" class="form-group pt-2 w-100">
                <div class="d-flex pt-1 justify-content-between">
                  <label for="birth Date"
                    >{{ $t("message.birthDate") }}
                    <span class="required-logo">*</span>
                  </label>

                  <label for="birth Date" @click="showBirthReason = true">
                    <span class="text-primary cursor-pointer">{{
                      $t("message.Why?")
                    }}</span>
                  </label>
                </div>

                <b-form-datepicker
                  id="BirthDate"
                  v-model="birthDate"
                  class="mb-2"
                ></b-form-datepicker>
                <span
                  v-if="birthDatestatus != 0"
                  class="invalid-feedback"
                  style="display: block"
                  >{{
                    birthDatestatus == 1
                      ? $t("message.birthDateRequire")
                      : "The Date of Birth should be DD/MM/YYYY format"
                  }}</span
                >
                <div class="invalid-feedback">
                  {{
                    OOErrors.first("birthDate") | inputNameLocale("birthDate")
                  }}
                </div>
              </div>
            </div>
            <div class="mt-auto">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary fs-1 fw-600"
                type="submit"
              >
                <span
                  class="material-icons float-right"
                  style="font-size: 1.5rem"
                >
                  arrow_forward_ios
                </span>
                <span>{{ $t("message.continue") }}</span>
              </button>
            </div>
          </form>
          <!--          multi form step 1 end-->

          <!--          multi form step 2 start-->
          <div v-if="multiStepIndex === 2" class="w-100">
            <div class="form-group w-100">
              <label for="email"
                >{{ $t("message.emailAddress") }}
                <span class="required-logo">*</span>
              </label>
              <input
                id="EmailId"
                ref="emailAddress"
                v-model="email"
                v-validate="'required|email'"
                :class="fullScreen && 'bg-gray'"
                aria-describedby="emailHelp"
                class="form-control"
                name="email"
                type="email"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("email") | inputNameLocale("email") }}
              </div>
            </div>
            <div v-if="isRolldStore()" class="form-group w-100">
              <label for="postcode"
                >{{ $t("message.postcode") }}
                <span class="required-logo">*</span>
              </label>
              <input
                id="postcode"
                v-model="postCode"
                v-validate="'required|numeric|min:3|max:4'"
                :class="fullScreen && 'bg-gray'"
                aria-describedby="postcode"
                class="form-control"
                name="postcode"
                type="text"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
              </div>
            </div>

            <div class="form-group pt-2 w-100">
              <label for="StateSelect"
                >{{ $t("message.state") }}
                <span class="required-logo">*</span>
              </label>

              <b-form-select
                v-model="state"
                :options="states"
                :placeholder="isRolldStore() ? $t('message.state') : ''"
              ></b-form-select>

              <div class="invalid-feedback">
                {{ OOErrors.first("state") | inputNameLocale("state") }}
              </div>
            </div>
            <div v-if="false" class="form-group">
              <label for="Phone Number"
                >{{ $t("message.phoneNumber") }}
                <span class="required-logo">*</span>
              </label>
              <input
                id="PhoneNumber"
                v-model="mobile"
                v-validate="{
                  required: true,
                  min: 8,
                  regex: this.getRegex(),
                  max: this.getMax(),
                }"
                :class="fullScreen && 'bg-gray'"
                class="form-control"
                name="phoneNumber"
                readonly
                type="text"
              />
              <div class="invalid-feedback">
                {{
                  OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber")
                }}
              </div>
            </div>
            <div class="form-group pt-2 w-100">
              <label for="password"
                >{{ $t("message.password") }}
                <span class="required-logo">*</span>
              </label>
              <div class="d-flex flex-grow-1">
                <input
                  id="passwordId"
                  ref="password"
                  v-model="password"
                  v-validate="'required|min:6'"
                  :class="fullScreen && 'bg-gray'"
                  :type="passwordVisible ? 'text' : 'password'"
                  autocomplete="new-password"
                  class="form-control"
                  name="password"
                />
                <span
                  class="material-icons md-36 p-0 eye"
                  @click="passwordVisible = !passwordVisible"
                >
                  {{ passwordVisible ? "visibility" : "visibility_off" }}
                </span>
              </div>

              <div class="invalid-feedback">
                {{ OOErrors.first("password") | inputNameLocale("password") }}
              </div>
            </div>
            <div v-if="!isRolldStore()" class="form-group pt-2 w-100">
              <div class="d-flex pt-1 justify-content-between">
                <label for="mobile"
                  >{{ $t("message.mobileNumber") }}
                  <span class="required-logo">*</span>
                </label>

                <label for="phoneNumber" @click="showMobileReason = true">
                  <span class="text-primary cursor-pointer">{{
                    $t("message.Why?")
                  }}</span>
                </label>
              </div>

              <div class="row">
                <div class="col-2">
                  <VueCountryCode
                    :preferredCountries="['au', 'us', 'gb']"
                    @onSelect="selectCountryCode"
                  />
                </div>

                <div class="col-10">
                  <input
                    id="mobile"
                    v-model="mobile"
                    v-validate="{
                      required: true,
                      min: 6,
                    }"
                    class="form-control bg-gray"
                    name="mobile"
                    type="tel"
                  />
                </div>

                <div class="invalid-feedback">
                  {{ OOErrors.first("mobile") | inputNameLocale("mobile") }}
                </div>
              </div>
            </div>

            <div v-if="googleLoaded && !isRolldStore" class="form-group w-100">
              <label for="address">{{ $t("message.address") }}</label>
              <vue-google-autocomplete
                id="OO_registeraddressinput"
                ref="gAutoComplete"
                :class="fullScreen && 'bg-gray'"
                :country="['au']"
                :enable-geolocation="true"
                :placeholder="getStartTypingPlaceholder"
                class="form-control"
                name="OO_registeraddressinput"
                @change="setAddress"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("address") | inputNameLocale("address") }}
              </div>
            </div>

            <div
              v-if="hqDoc.TermsAndConditions"
              class="w-60 mt-4 justify-content-center"
            >
              <a href="#" @click.prevent="$emit('toggleTC')">
                <p
                  style="
                    font-size: 0.6875rem;
                    line-height: 1.4;
                    text-align: center;
                  "
                  v-html="$t('message.termsOfUsePrivacyStatement')"
                ></p>
              </a>
            </div>

            <div class="mt-3">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary fs-1 fw-600"
                type="submit"
              >
                <span v-if="loading" class="float-right">
                  <i class="spin float-right" />
                </span>
                <span
                  v-else
                  class="material-icons float-right"
                  style="font-size: 1.5rem"
                >
                  arrow_forward_ios
                </span>
                <span>{{ $t("message.register") }}</span>
              </button>
            </div>
          </div>
          <!--          multi form step 2 end-->

          <!--          multi form step 3 start verify otp -->
          <div v-if="multiStepIndex === 3" class="w-100">
            <div
              class="w-100 form-group d-flex flex-wrap justify-content-center align-items-center"
            >
              <OtpInput
                ref="otpInput"
                :is-input-num="true"
                :num-inputs="6"
                :should-auto-focus="true"
                autocomplete="one-time-code"
                input-classes="otp-input"
                separator=""
                @on-complete="verifyPhoneNumber"
              />

              <div
                class="w-85 mt-4 d-flex align-items-center justify-content-center"
              >
                <span>{{ $t("message.smsResendDescription") }}</span>
                <button
                  :disabled="!enableResendBtn || loading"
                  :style="desktopStyles.LinkColorTxt"
                  class="btn btn-link pl-1 resend-btn"
                  type="button"
                  @click="resendSms"
                >
                  {{ $t("message.smsResendButton") }}
                  <span v-show="!enableResendBtn && !loading"
                    >({{ resendWait }})</span
                  >
                </button>
              </div>

              <!--              <div v-show="error" class="w-75 mt-4">-->
              <!--                <div class="alert alert-danger" role="alert">-->
              <!--                  <strong>{{ error }}</strong>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>

            <div class="mt-3">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary fs-1 fw-600"
                type="submit"
              >
                <span v-if="loading">
                  <i class="spin float-right" />
                </span>
                <span
                  v-else
                  class="material-icons float-right"
                  style="font-size: 1.5rem"
                >
                  arrow_forward_ios
                </span>
                <span>{{ $t("message.verifyCode") }}</span>
              </button>
            </div>
          </div>

          <!--          multi form step 3 end-->

          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
        <!--        multi step register full screen form ends -->

        <!--   non full screen branded form start  -->
        <form
          v-else-if="isBranded() && !fullScreen"
          autocomplete="off"
          class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
          :class="isMobile() && 'container'"
          @submit.prevent="register"
        >
          <div
            v-if="FacebookLogin || GoogleLogin"
            class="w-75 mb-3 d-flex justify-content-center"
          >
            <strong>{{ $t("message.signInWith") }}</strong>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>

          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login @close-overlay="$emit('close-overlay')" />
            </div>
          </div>
          <h4
            class="w-75 mt-2 d-flex pt-2"
            :class="
              fullScreen ? 'justify-content-start' : 'justify-content-center'
            "
          >OR</h4>
          <h3
            class="w-75 mt-3 d-flex pt-2"
            :class="
              fullScreen ? 'justify-content-start' : 'justify-content-center'
            "
          >
            {{ $t("message.createYourAccount") }}
          </h3>
          <div v-if="fullScreen" class="justify-content-start w-75 d-flex pt-2">
            <h5 class="pr-2 font-weight-light">
              {{ $t("message.alreadyMember") }}
            </h5>
            <h5 class="text-primary cursor-pointer" @click="goToSignIn(0)">
              {{ $t("message.signInHere") }}
            </h5>
          </div>

          <div class="form-group w-75">
            <label for="First Name"
              >{{ $t("message.name") }}
              <span class="required-logo">*</span></label
            >
            <input
              id="FullName"
              v-model="fullName"
              v-validate="'required|min:2'"
              :class="fullScreen && 'bg-gray'"
              class="form-control"
              name="fullName"
              type="text"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("fullName") | inputNameLocale("fullName") }}
            </div>
          </div>

          <div v-if="!isRolldStore()" class="form-group w-75 pt-2">
            <div class="d-flex pt-1 justify-content-between">
              <label for="birth Date"
                >{{ $t("message.birthDate") }}
                <span class="required-logo">*</span>
              </label>
            </div>

            <!--            <date-pick-->
            <!--              id="BirthDate"-->
            <!--              name="birthDate"-->
            <!--              v-model="birthDate"-->
            <!--              :format="'DD/MM/YYYY'"-->
            <!--              :inputAttributes="{-->
            <!--                placeholder: 'DD/MM/YYYY',-->
            <!--                class: ['form-control', bdstatus, {'bg-gray' : fullScreen}],-->
            <!--              }"-->
            <!--              @input="isValidDate($event)"-->
            <!--              :parseDate="parseDate"-->
            <!--            ></date-pick>-->

            <b-form-datepicker
              :format="'DD/MM/YYYY'"
              id="BirthDate"
              v-model="birthDate"
              class="mb-2 b-date-picker"
            ></b-form-datepicker>
            <span
              v-if="birthDatestatus != 0"
              class="invalid-feedback"
              style="display: block"
              >{{
                birthDatestatus == 1
                  ? $t("message.birthDateRequire")
                  : "The Date of Birth should be DD/MM/YYYY format"
              }}</span
            >
            <div class="invalid-feedback">
              {{ OOErrors.first("birthDate") | inputNameLocale("birthDate") }}
            </div>
          </div>
          <!--          <div class="form-group w-75">-->
          <!--            <label for="Last Name"-->
          <!--              >{{ $t("message.lastName") }}-->
          <!--              <span class="required-logo">*</span>-->
          <!--            </label>-->
          <!--            <input-->
          <!--              v-validate="'required|min:2|alpha'"-->
          <!--              id="LastName"-->
          <!--              v-model="lastName"-->
          <!--              name="lastName"-->
          <!--              type="text"-->
          <!--              class="form-control"-->
          <!--              :class="fullScreen && 'bg-gray'"-->
          <!--            />-->
          <!--            <div class="invalid-feedback">-->
          <!--              {{ OOErrors.first("lastName") | inputNameLocale("lastName") }}-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="form-group w-75">
            <label for="email"
              >{{ $t("message.emailAddress") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="EmailId"
              ref="emailAddress"
              v-model="email"
              v-validate="'required|email'"
              :class="fullScreen && 'bg-gray'"
              aria-describedby="emailHelp"
              class="form-control"
              name="email"
              type="email"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("email") | inputNameLocale("email") }}
            </div>
          </div>
          <div v-if="isRolldStore()" class="form-group w-75">
            <label for="postcode"
              >{{ $t("message.postcode") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="postcode"
              v-model="postCode"
              v-validate="'required|numeric|min:3|max:4'"
              :class="fullScreen && 'bg-gray'"
              aria-describedby="postcode"
              class="form-control"
              name="postcode"
              type="text"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
            </div>
          </div>
          <div v-if="!isRolldStore()" class="form-group w-75 pt-2">
            <label for="ConfirmEmailId">
              {{ $t("message.confirmEmail") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="ConfirmEmailId"
              v-model="confirmEmail"
              v-validate="'required|confirmed:emailAddress'"
              :class="fullScreen && 'bg-gray'"
              class="form-control"
              name="confirmEmail"
              type="email"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("confirmEmail") | inputNameLocale("confirmEmail")
              }}
            </div>
          </div>
          <div class="form-group w-75 pt-2">
            <label for="StateSelect"
              >{{ $t("message.state") }}
              <span class="required-logo">*</span>
            </label>

            <b-form-select
              :placeholder="isRolldStore() ? $t('message.state') : ''"
              v-model="state"
              :options="states"
            ></b-form-select>
            <!--            <select-->
            <!--              v-validate="'required'"-->
            <!--              id="StateSelect"-->
            <!--              :placeholder="isRolldStore() ? $t('message.state') : ''"-->
            <!--              name="state"-->
            <!--              v-model="state"-->
            <!--              ref="stateRef"-->
            <!--              class="form-control"-->
            <!--              :class="fullScreen && 'bg-gray'"-->
            <!--            >-->
            <!--              <option :value="''" disabled="disabled" selected="selected">-->
            <!--                {{ $t("message.selectYourstate") }}-->
            <!--              </option>-->
            <!--              <option-->
            <!--                v-for="(state, index) in states"-->
            <!--                :key="index"-->
            <!--                :value="state"-->
            <!--              >-->
            <!--                {{ state }}-->
            <!--              </option>-->
            <!--            </select>-->
            <div class="invalid-feedback">
              {{ OOErrors.first("state") | inputNameLocale("state") }}
            </div>
          </div>
          <div v-if="false" class="form-group w-75">
            <label for="Phone Number"
              >{{ $t("message.phoneNumber") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="PhoneNumber"
              v-model="mobile"
              v-validate="{
                required: true,
                min: 8,
                regex: this.getRegex(),
                max: this.getMax(),
              }"
              :class="fullScreen && 'bg-gray'"
              class="form-control"
              name="phoneNumber"
              readonly
              type="text"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("phoneNumber") | inputNameLocale("phoneNumber")
              }}
            </div>
          </div>
          <div class="form-group w-75 pt-2">
            <label for="password"
              >{{ $t("message.password") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="passwordId"
              ref="password"
              v-model="password"
              v-validate="'required|min:6'"
              :class="fullScreen && 'bg-gray'"
              autocomplete="new-password"
              class="form-control"
              name="password"
              type="password"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("password") | inputNameLocale("password") }}
            </div>
          </div>
          <div class="form-group w-75 pt-2">
            <label for="Confirm Password">
              {{ $t("message.confirmPassword") }}
              <span class="required-logo">*</span>
            </label>
            <input
              id="ConfirmPasswordId"
              v-model="confirmPassword"
              v-validate="'required|confirmed:password'"
              :class="fullScreen && 'bg-gray'"
              class="form-control"
              name="confirmPassword"
              type="password"
            />
            <div class="invalid-feedback">
              {{
                OOErrors.first("confirmPassword")
                  | inputNameLocale("confirmPassword")
              }}
            </div>
          </div>

          <div v-if="googleLoaded && !isRolldStore" class="form-group w-75">
            <label for="address">{{ $t("message.address") }}</label>
            <vue-google-autocomplete
              id="OO_registeraddressinput"
              ref="gAutoComplete"
              :class="fullScreen && 'bg-gray'"
              :country="['au']"
              :enable-geolocation="true"
              :placeholder="getStartTypingPlaceholder"
              class="form-control"
              name="OO_registeraddressinput"
              @change="setAddress"
            />
            <div class="invalid-feedback">
              {{ OOErrors.first("address") | inputNameLocale("address") }}
            </div>
          </div>

          <div
            v-if="hqDoc.TermsAndConditions"
            class="w-60 mt-4 justify-content-center"
          >
            <a href="#" @click.prevent="$emit('toggleTC')">
              <p
                style="
                  font-size: 0.6875rem;
                  line-height: 1.4;
                  text-align: center;
                "
                v-html="$t('message.termsOfUsePrivacyStatement')"
              ></p>
            </a>
          </div>
          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary fs-1 fw-600"
              type="submit"
            >
              <span v-if="loading">
                <i class="spin float-right" />
              </span>
              <span
                v-else
                class="material-icons float-right"
                style="font-size: 1.5rem"
              >
                arrow_forward_ios
              </span>
              <span>{{ $t("message.register") }}</span>
            </button>
          </div>

          <div class="w-75 mt-4 d-flex justify-content-center font-weight-bold">
            {{ $t("message.alreadyHaveProfile") }}?&nbsp;
            <a
              :style="desktopStyles.LinkColorTxt"
              href="#"
              @click="goToSignIn(0)"
              >{{ $t("message.signIn") }}</a
            >
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </form>
        <!--   non full screen branded form end  -->

        <!--        form for non branded stores   -->
        <div v-else>
          <form
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
            ref="register"
            v-if="step === 2"
          >
            <h4 class="w-75 mt-3 mb-5 d-flex justify-content-center">
              {{ $t("message.enterCodeSentTo") }}
              {{ this.countryCode + this.mobile }}
            </h4>

            <div class="form-group w-full">
              <OtpInput
                ref="otpInput"
                input-classes="otp-input"
                autocomplete="one-time-code"
                separator="-"
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-complete="verifyOtp"
              />
            </div>

            <div
              class="w-85 mt-4 d-flex align-items-center justify-content-center"
            >
              <span>{{ $t("message.smsResendDescription") }}</span>
              <button
                type="button"
                class="btn btn-link pl-1 resend-btn"
                :disabled="!enableResendBtn || loading"
                :style="desktopStyles.LinkColorTxt"
                @click="resendSms"
              >
                {{ $t("message.smsResendButton") }}
                <span v-show="!enableResendBtn && !loading"
                  >({{ resendWait }})</span
                >
              </button>
            </div>

            <div class="w-75 mt-3">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                type="submit"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
              >
                {{ $t("message.confirm") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>

            <div v-show="error" class="w-75 mt-4">
              <div class="alert alert-danger" role="alert">
                <strong>{{ error }}</strong>
              </div>
            </div>
          </form>

          <!--        Enter Otp Form End  -->
          <form
            class="pt-2 pb-4 d-flex flex-wrap justify-content-center"
            @submit.prevent="goToVerifyCode"
            autocomplete="off"
            v-else
          >
            <h3 class="w-75 mt-3 mb-5 d-flex justify-content-center">
              {{ $t("message.createYourAccount") }}
            </h3>

            <div class="form-group w-75">
              <label for="mobile"
                >{{ $t("message.phoneNumber") }}
                <span class="required-logo">*</span></label
              >

              <div class="row">
                <div class="col-2">
                  <VueCountryCode
                    @onSelect="selectCountryCode"
                    :preferredCountries="['au', 'us', 'gb']"
                  />
                </div>

                <div class="col-10">
                  <input
                    v-validate="{
                      required: true,
                      min: 6,
                    }"
                    id="mobile"
                    v-model="mobile"
                    name="mobile"
                    type="tel"
                    class="form-control"
                  />
                </div>
              </div>

              <div class="invalid-feedback">
                {{ OOErrors.first("mobile") | inputNameLocale("mobile") }}
              </div>
            </div>

            <div class="form-group w-75">
              <label for="Full Name"
                >{{ $t("message.fullName") }}
                <span class="required-logo">*</span></label
              >
              <input
                v-validate="'required|min:2'"
                id="Fullname"
                v-model="fullName"
                name="fullName"
                type="text"
                class="form-control"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("firstName") | inputNameLocale("firstName") }}
              </div>
            </div>
            <div class="form-group w-75">
              <label for="email"
                >{{ $t("message.emailAddress") }}
                <span class="required-logo">*</span>
              </label>
              <input
                id="EmailId"
                v-model="email"
                v-validate="'required|email'"
                type="email"
                name="email"
                class="form-control"
                aria-describedby="emailHelp"
                ref="emailAddress"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("email") | inputNameLocale("email") }}
              </div>
            </div>
            <div v-if="isRolldStore()" class="form-group w-75">
              <label for="postcode"
                >{{ $t("message.postcode") }}
                <span class="required-logo">*</span>
              </label>
              <input
                id="postcode"
                v-model="postCode"
                v-validate="'required|numeric|min:3|max:4'"
                type="text"
                name="postcode"
                class="form-control"
                aria-describedby="postcode"
              />
              <div class="invalid-feedback">
                {{ OOErrors.first("postcode") | inputNameLocale("postcode") }}
              </div>
            </div>

            <div
              class="w-60 mt-4 justify-content-center"
              v-if="hqDoc.TermsAndConditions"
            >
              <a href="#" @click.prevent="$emit('toggleTC')">
                <p
                  v-html="$t('message.termsOfUsePrivacyStatement')"
                  style="
                    font-size: 0.6875rem;
                    line-height: 1.4;
                    text-align: center;
                  "
                ></p>
              </a>
            </div>
            <div class="w-75 mt-3">
              <button
                :disabled="loading"
                :style="desktopStyles.btn"
                type="submit"
                class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
              >
                {{ $t("message.register") }}
                <span v-show="loading">
                  <i class="spin ml-4" />
                </span>
              </button>
            </div>

            <div
              class="w-75 mt-4 d-flex justify-content-center font-weight-bold"
              v-if="!fullScreen"
            >
              {{ $t("message.alreadyHaveProfile") }}?&nbsp;
              <a
                :style="desktopStyles.LinkColorTxt"
                href="#"
                @click="goToSignIn(0)"
                >{{ $t("message.signIn") }}</a
              >
            </div>
            <div v-show="error" class="w-75 mt-4">
              <div class="alert alert-danger" role="alert">
                <strong>{{ error }}</strong>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-center"
      v-model="showBirthReason"
      :hide-footer="true"
      :hide-header="true"
      centered
      content-class="br-10"
    >
      <div class="p-3 d-flex flex-column text-justify">
        <h4 class="font-20">{{ $t("message.whyNeedDob") }}</h4>
        <p class="my-4 mb-5">{{ $t("message.whyNeedDobText") }}</p>
        <!--       close modal button-->
        <div class="mt-5">
          <button
            class="btn btn-block btn-primary br-10"
            @click="showBirthReason = false"
          >
            Close
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-center"
      v-model="showMobileReason"
      :hide-footer="true"
      :hide-header="true"
      centered
      content-class="br-10"
    >
      <div class="p-3 d-flex flex-column text-justify">
        <h4 class="font-20">{{ $t("message.whyNeedMobile") }}</h4>
        <p class="my-4 mb-5">{{ $t("message.whyNeedMobileText") }}</p>
        <!--       close modal button-->
        <div class="mt-5">
          <button
            class="btn btn-block btn-primary br-10"
            @click="showMobileReason = false"
          >
            Close
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../sharedscripts/user/register.js";
import login from "../../sharedscripts/user/login.js";
import { mapActions, mapGetters } from "vuex";
import { $$ } from "./../../sharedscripts/OO_jquery";
import "vue-date-pick/dist/vueDatePick.css";
import OtpInput from "@bachdgvn/vue-otp-input";
import VueCountryCode from "vue-country-code";
import * as userService from "@/api/services/userService";
import AuthProvidersLogin from "./AuthProvidersLogin";
export default {
  components: {
    OtpInput,
    VueCountryCode,
    VueGoogleAutocomplete,
    AuthProvidersLogin,
  },
  props: {
    storeid: {
      type: String,
      default: null,
    },
    forgift: {
      type: Boolean,
      default: false,
    },

    //prop if register page is rendered on full screen to handle navigation differently
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      confirmEmail: "",
      // phoneNumber: "",
      password: "",
      birthDate: "1990-01-01",
      confirmPassword: "",
      loading: false,
      address: "",
      error: "",
      googleLoaded: false,
      birthDatestatus: 0,
      states: ["NSW", "VIC", "QLD", "TAS", "SA", "WA", "NT", "ACT"],
      state: "",
      postCode: "",
      resendWait: 30, //seconds
      smsTimer: null,

      mobile: "",
      // step 1 displays form
      // step 2 displays OTP input for phone number auth
      step: 1,
      appVerifier: "",
      otp: "",
      countryCode: "+61",
      verificationId: "",

      // single register page index
      // 1 - user details
      // 2 - mobile number
      // 3 - OTP
      multiStepIndex: 1,
      showBirthReason: false,
      showMobileReason: false,
      passwordVisible: false,
    };
  },
  updated() {
    if (this.$refs.gAutoComplete) {
      this.$refs.gAutoComplete.$refs.autocomplete.autocomplete = "none";
    }
    if (this.address) {
      document.getElementById("OO_registeraddressinput").value = this.address;
    }
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "desktopStyles",
      "viewConfig",
      "currentStoreDoc",
      "hqDoc",
      "getOverlayIndex",
    ]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    },
    getStartTypingPlaceholder() {
      return this.$t("message.StartTyping");
    },
    bdstatus() {
      return this.birthDatestatus != 0 ? "invaliddatetime" : "";
    },
    enableResendBtn() {
      return this.resendWait === 0;
    },
    fullName: {
      get() {
        if (!this.firstName || !this.lastName.length) {
          return this.firstName;
        }
        return this.firstName + " " + this.lastName;
      },
      set(val) {
        if (!val) return;
        let names = val.split(" ");

        this.firstName = names[0];
        this.lastName = names.slice(1, names.length + 1).join(" ");
      },
    },
  },
  mounted() {
    this.setStoreLoaded();
    shared.mounted(true, this);
    $$("#drawer").on("touchstart", this.autocompleteblur);
    $$("#drawer").on("scroll", this.autocompleteblur);
    this.initReCaptcha();
  },
  methods: {
    ...shared.methods,
    ...login.methods,
    ...mapActions(["setOverlayIndex"]),
    autocompleteblur() {
      $$("#OO_registeraddressinput").blur();
    },
    parseDate(dateString) {
      var date = dateString.split("/");
      if (
        date[0] &&
        date[0].length > 0 &&
        date[1] &&
        date[1].length > 0 &&
        date[2] &&
        date[2].length == 4
      ) {
        return new Date(date[2], date[1] - 1, date[0]);
      } else {
        return undefined;
      }
    },
    async goToVerifyCode() {
      await this.sendOtp();
      this.smsTimer = setInterval(() => {
        if (this.resendWait > 0) this.resendWait--;
      }, 1000);
    },

    selectCountryCode(value) {
      this.countryCode = `+${value.dialCode}`;
    },

    goToSignIn(index = 0) {
      if (this.fullScreen) {
        this.$router.push("/store/" + this.$route.params.storename + "/login");
        return;
      }
      this.setOverlayIndex(index);
    },
    async goToStepTwo() {
      const valid = await this.$validator.validateAll();
      if (!valid) return;
      this.multiStepIndex = 2;
    },

    async resendSms() {
      this.loading = true;
      await userService.sendSmsVerification();
      this.resendWait = 30;
      this.loading = false;
    },
    async verifyPhoneNumber(smsCode) {
      if (!smsCode) {
        this.error = this.$t("message.smsCodeIsIncorrect");
      }
      this.error = "";
      this.loading = true;
      let sms = await userService.getUserSms({
        id: this.user.id,
      });
      if (smsCode != sms) {
        this.error = this.$t("message.smsCodeIsIncorrect");
        this.loading = false;
        return;
      }
      await userService.verifyUserPhone({
        id: this.user.id,
      });
      await this.$router.push("/store/" + this.$route.params.storename);
      this.loading = false;
    },
    goBackMultiStepForm() {
      this.multiStepIndex =
        this.multiStepIndex < 2 ? 1 : this.multiStepIndex - 1;
    },
  },
  watch: {
    address() {
      document.getElementById("drawer").style.overflow = "auto";
      document.body.style.overflow = "auto";
    },
  },
};
</script>
<style scoped>
.required-logo {
  color: red;
}
.vdpComponent {
  display: block;
}
</style>
